export function formatSchedulePicker(arrayRangePickers = []) {
  const formattedHours = arrayRangePickers.flatMap((range) => {
    const weekday = range.day;
    const hours = range.hours.map((hour) => {
      const start_hour = hour.start.substring(0, 5);
      const end_hour = hour.end.substring(0, 5);

      return {
        weekday,
        start_hour,
        end_hour,
      };
    });

    return hours;
  });

  return formattedHours.length ? formattedHours : undefined;
}
